import React from 'react';
import BarkProfileCard from '../profile-card';
import SellerContactBlockNew from '../seller-contact-block/indexNew';
import { NewContactCardWrapper } from './index.style';

interface NewContactCardProps {
    adSource?: string;
    scoreAndReviews: {
        average: number;
        total: number;
        topTips: string;
        bottomTips: string;
        type: string;
    };
    isMobile: boolean;
}

const NewContactCard: React.FC<NewContactCardProps> = ({ scoreAndReviews, adSource = 'GT', isMobile }) => {
    return (
        <NewContactCardWrapper>
            <BarkProfileCard scoreAndReviews={scoreAndReviews} adSource={adSource} isMobile={isMobile} />
            <SellerContactBlockNew />
        </NewContactCardWrapper>
    );
};

export default NewContactCard;
